import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from './Particle';
import ProjectCard from "./ProjectCard";
import project3Image from "../Assets/project3Image.jpeg";
import project1Image from "../Assets/project1Image.jpeg";
import project2Image from "../Assets/project2Image.jpeg";
import project4Image from '../Assets/project4Image.jpeg';
import project5Image from '../Assets/project5Image.jpeg'

function Projects() {
  return (
    <Container fluid className="projects-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          <strong className="purple">My Projects</strong>
        </h1>
        <Row>
          <Col md={4}>
            <ProjectCard
              title={<a href="https://better-buys-store.netlify.app/">Project 1 </a>}
              description="E-commerce website."
              imageUrl={project1Image}
              projectUrl="https://github.com/Rohankumarmenu/betterbuys"
            />
          </Col>
          <Col md={4}>
            <ProjectCard
              title="Project 2"
              description="Quiz website."
              imageUrl={project2Image}
              projectUrl="https://github.com/Rohankumarmenu/Quizapp"
            />
          </Col>
          <Col md={4}>
            <ProjectCard
              title={<a href=  "https://rohankumarmenu.github.io/yoga-pose-estimation/" >Project 3</a>}
              description="yoga pose detection."
              imageUrl={project3Image}
              projectUrl="https://github.com/Rohankumarmenu/yoga-pose-estimation" 
            />
          </Col>
        </Row>

        <div style={{ marginTop: "20px" }}></div>
        
        <Row>
          <Col md={4}>
            <ProjectCard
              title="Project 4"
              description="learn English "
              imageUrl={project4Image}
              projectUrl="https://github.com/Rohankumarmenu/languagelearn"
            />
          </Col>

          <Col md={4}>
            <ProjectCard
              title="Project 5"
              description="Anime Website"
              imageUrl={project5Image}
              projectUrl="https://github.com/Rohankumarmenu/Anime"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
